{
  "account": "Account",
  "account_setup": "Account instellen",
  "change_password": "Wachtwoord wijzigen",
  "check_fields": "Controleer de gemarkeerde velden.",
  "current_password_hint": "Vul je huidige wachtwoord in",
  "fullname": "Jouw naam",
  "fullname_hint": "Bijvoorbeeld Karel van Tellingen. Je naam wordt opgenomen in het verslag van deze invoersessie.",
  "fullname_subtext": "(roepnaam + achternaam)",
  "invalid_fullname": "In de volledige naam mogen geen tabs of enter zitten.",
  "invalid_username": "Gebruik alleen letters zonder accenten, cijfers en tekens zoals _ - + . !. Spaties zijn niet toegestaan.",
  "login": "Inloggen",
  "login_success": "Inloggen gelukt",
  "logout": "Afmelden",
  "not_saved": "Wijzigingen niet opgeslagen",
  "password": "Wachtwoord",
  "password_changed": "Je wachtwoord is succesvol gewijzigd",
  "password_hint": "Gebruik minimaal 13 karakters. Je hebt dit wachtwoord nodig als je na een pauze opnieuw wilt inloggen.",
  "password_length_rule": "Gebruik minimaal 13 karakters",
  "password_login_hint": "Eerder ingelogd? Vul het wachtwoord in dat je zelf hebt ingesteld. Nog niet eerder ingelogd? Gebruik het wachtwoord dat je van de coördinator hebt gekregen.",
  "password_mismatch": "De wachtwoorden komen niet overeen",
  "password_new": "Kies nieuw wachtwoord",
  "password_repeat": "Herhaal wachtwoord",
  "personalize_account": "Personaliseer je account",
  "setting_up_account": "We gaan je account instellen voor gebruik. Vul onderstaande gegevens in om verder te gaan.",
  "username": "Gebruikersnaam",
  "username_hint": "Je kan deze niet aanpassen. Log volgende keer weer met deze gebruikersnaam in.",
  "choose_username_hint": "Dit is de naam waarmee je inlogt. Hoofdletters en kleine letters maken geen verschil. Gebruik alleen letters zonder accenten, cijfers en leestekens. Spaties zijn niet toegestaan.",
  "username_login_hint": "De naam op het briefje dat je van de coördinator hebt gekregen."
}
